import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { LineChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis, Area, AreaChart } from "recharts";

export default function Analytics() {
  const [d, setD] = useState(null);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/analytics/summary");
      setD(data);
    })();
  }, []);
  if (!d) return <div className="p-10 text-meta">Loading…</div>;

  return (
    <div className="min-h-screen bg-[#FAFAFA] p-6 lg:p-10" data-testid="analytics-page">
      <h1 className="font-display text-3xl font-bold text-ink">Analytics</h1>
      <p className="text-sm text-meta mt-1">Revenue · attribution · AI performance</p>

      <div className="mt-8 grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 surface p-6">
          <h3 className="font-display text-lg font-bold text-ink mb-4">Revenue (14d)</h3>
          <div className="h-64">
            <ResponsiveContainer>
              <AreaChart data={d.timeseries}>
                <defs>
                  <linearGradient id="g1" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#8B5CF6" stopOpacity={0.6} />
                    <stop offset="100%" stopColor="#8B5CF6" stopOpacity={0} />
                  </linearGradient>
                  <linearGradient id="g2" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#10B981" stopOpacity={0.5} />
                    <stop offset="100%" stopColor="#10B981" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <XAxis dataKey="date" tick={{ fill: "#71717a", fontSize: 11 }} tickLine={false} axisLine={false} />
                <YAxis tick={{ fill: "#71717a", fontSize: 11 }} tickLine={false} axisLine={false} />
                <Tooltip contentStyle={{ background: "#FFFFFF", border: "1px solid #E4E4E7", borderRadius: 12, fontSize: 12, color: "#09090B" }} />
                <Area type="monotone" dataKey="revenue" stroke="#7C3AED" fill="url(#g1)" strokeWidth={2} />
                <Area type="monotone" dataKey="ai_revenue" stroke="#059669" fill="url(#g2)" strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="surface p-6">
          <h3 className="font-display text-lg font-bold text-ink mb-3">AI performance</h3>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between"><span className="text-meta">Replies sent</span><span className="font-bold text-ink">{d.ai_perf.replies_sent}</span></div>
            <div className="flex justify-between"><span className="text-meta">Avg confidence</span><span className="font-bold text-success">{(d.ai_perf.avg_confidence*100).toFixed(0)}%</span></div>
            <div className="flex justify-between"><span className="text-meta">Human escalations</span><span className="font-bold text-ink">{d.ai_perf.escalations}</span></div>
            <div className="flex justify-between"><span className="text-meta">AI cost</span><span className="font-bold text-ink">${d.ai_perf.cost_usd}</span></div>
            <div className="flex justify-between"><span className="text-meta">ROI multiple</span><span className="font-display text-lg font-extrabold text-success">{d.ai_perf.roi_multiple}x</span></div>
          </div>
        </div>
      </div>

      <div className="mt-4 grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 surface p-6">
          <h3 className="font-display text-lg font-bold text-ink mb-4">Content → Revenue attribution</h3>
          <div className="divide-y divide-line">
            {d.content.map(c => (
              <div key={c.content_id} className="py-3 flex items-center justify-between gap-3 text-sm">
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-ink truncate">{c.title}</p>
                  <p className="text-[11px] text-meta">{c.type} · {c.conversions} conversions · {(c.conversion_rate*100).toFixed(1)}%</p>
                </div>
                <p className="font-display text-xl font-extrabold text-success shrink-0">${c.revenue.toLocaleString()}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="surface p-6">
          <h3 className="font-display text-lg font-bold text-ink mb-4">Funnel</h3>
          <div className="space-y-2.5">
            {d.funnel.map((s) => {
              const top = d.funnel[0].value;
              const pct = (s.value / top) * 100;
              return (
                <div key={s.label} className="space-y-1">
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-meta font-medium">{s.label}</span>
                    <span className="text-ink font-bold">{s.value.toLocaleString()}</span>
                  </div>
                  <div className="h-2 rounded-full bg-zinc-100 overflow-hidden">
                    <div className="h-full rounded-full ashra-gradient-bg" style={{ width: `${pct}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
